import { useContext } from 'react';
import { AuthUserContext } from 'src/react/_shared/Context/AuthUserContext';

export const useDeniedRootRoutes = () => {
  const { activeRole, companiesWithEmployeePrefsEnabled } = useContext(AuthUserContext);
  const deniedRoutes = new Set();

  const isEmployeePreferencesEnabled = companiesWithEmployeePrefsEnabled.length > 0;

  if (!isEmployeePreferencesEnabled) {
    deniedRoutes.add('employee-preferences');
  }

  if (!['admin', 'superadmin'].includes(activeRole)) {
    deniedRoutes.add('reports');
    deniedRoutes.add('admin');
  }

  if (!window.Intercom) {
    deniedRoutes.add('help');
  }

  return deniedRoutes;
};
